import { useMemo } from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import { CreateTaskInventory } from '@bringg/types';
import { Button, Image, InputNumber, List, Typography } from 'antd';

import './styles.scss';

interface Props {
  inventories: CreateTaskInventory[];
  onChange: (i: CreateTaskInventory[]) => void;
}

export function InventoriesList({ inventories, onChange }: Props) {
  const totalPrice = useMemo(
    () => inventories.reduce((total, item) => total + (item.original_quantity as number) * (item.price as number), 0),
    [inventories]
  );

  const updateCountFor = (item: CreateTaskInventory) => (original_quantity: number) => {
    onChange(
      inventories.map((inventory) => {
        if (inventory !== item) {
          return inventory;
        }

        return {
          ...inventory,
          original_quantity,
        };
      })
    );
  };

  const removeInventory = (item: CreateTaskInventory) => () => {
    onChange(inventories.filter((i) => i !== item));
  };

  return (
    <div className="inventory-list">
      <List
        dataSource={inventories}
        renderItem={(item) => (
          <List.Item>
            <div className="inventory-image-container">
              <Image className="inventory-image" src={item.image} />
            </div>
            <div className="inventory-description">
              <Typography.Title level={5}>{item.name}</Typography.Title>
              <Typography.Text>{item.description}</Typography.Text>
              <div>
                <Typography.Text strong={true}>${item.price}</Typography.Text>
              </div>
            </div>

            <div className="inventory-actions">
              <InputNumber min={1} value={item.original_quantity} onChange={updateCountFor(item)} />
              <Button
                className="remove"
                type="ghost"
                shape="circle"
                icon={<DeleteOutlined />}
                onClick={removeInventory(item)}
              />
            </div>
          </List.Item>
        )}
      />
      <div className="total-price">
        <Typography.Text strong={true}>Total: ${totalPrice}</Typography.Text>
      </div>
    </div>
  );
}
